var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-create"},[_c('OrderComponent',{attrs:{"isCreate":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }